import * as React from 'react';
import * as _ from 'lodash';
import createTableContext, {TableDataSource} from 'cl-table/redux/createTableContext';
import {ColumnsConfig, RowDataType, Selection, TableState} from 'cl-table/redux/actions';
import ReduxTable from 'cl-table/redux/ReduxTable';
import {getFieldsToRevise, getUpdatedFieldValue} from '../ebayListingSelectors';
import {TableFilterProps} from 'cl-table/TableFilter/TableFilter';
import connectWithRouter from '../../../../shared/components/redux/connectWithRouter';
import {convertSelectionToIDs} from '../../../../shared/ActionsManager/VariationsActions/VariationsActionsHelpers';
import ActionsPanel, {ActionsPanelProps} from 'cl-layout/ActionsPanel';
import {createStyles, WithStyles, withStyles} from '@material-ui/core/styles';

type TableStateProps = 'columns' | 'data';

interface ListerTableProps<RowData extends RowDataType = RowDataType> {
  name: string;
  config?: object;
  thumbnail?: boolean;
  selectable?: boolean;
  filterProps?: Partial<TableFilterProps>;
  updateRow: (columnName, rows, rowId, value) => object[];
  rows: object;
  fieldToRevise: object;
  onChange: (value) => void;
}

@connectWithRouter(
  (state, props) => ({
    rows: getUpdatedFieldValue(state, props.fieldName),
    fieldToRevise: getFieldsToRevise(state)[props.fieldName] || {},
  }),
  {}
)
class ListerTable<RowData extends RowDataType> extends React.PureComponent<
  ListerTableProps<RowData> & Pick<TableState<RowData>, TableStateProps> & ActionsPanelProps & WithStyles<typeof styles>
> {
  public static defaultProps: Partial<ListerTableProps> = {
    thumbnail: true,
    selectable: false,
    config: {id: '_id'},
    filterProps: {preventMoreFilters: true},
  };

  private readonly ListerTableContext;

  constructor(props) {
    super(props);
    const {name, config, thumbnail, selectable, filterProps} = props;
    this.ListerTableContext = createTableContext<RowData>({
      name: name,
      getInitialState: () => {
        return {
          columnsConfig: new ColumnsConfig<RowData>(config),
          virtualized: false,
        };
      },
      onChange: this.onChange,
      props: {
        thumbnail: thumbnail,
        selectable: selectable,
        filterProps: filterProps,
      },
      dataSource: TableDataSource.EXTERNAL_LOADED,
      showAllVisibleColumns: true,
    });
  }

  onChange = async (selection: Selection, columnName: string, value) => {
    const {rows, updateRow, onChange, fieldToRevise} = this.props;
    let idsToUpdate = convertSelectionToIDs(selection, _.keys(rows));
    let updatedField = {};
    _.forEach(idsToUpdate, rowId => {
      updatedField = {...updatedField, ...updateRow(columnName, rows, rowId, value)};
    });
    updatedField = {...fieldToRevise, ...updatedField}; // handles both add and update
    onChange(updatedField);
  };

  render() {
    const {
      data,
      columns,
      actions,
      classes: {root},
    } = this.props;
    const ListerTableContext = this.ListerTableContext;
    return (
      <div className={root}>
        <ListerTableContext data={data} columns={columns}>
          {actions ? <ActionsPanel sticky actions={actions} /> : undefined}
          <ReduxTable />
        </ListerTableContext>
      </div>
    );
  }
}

const styles = createStyles({
  root: {
    overflow: 'auto',
  },
});

export default withStyles(styles)(ListerTable);
